// Journal Getters

export const getJournalList = state => {
  return state.journalList
}
